export const BLACKLIST_LIST_PAGE_UUID = '54195e32-e1e9-414a-b8f1-8dae1233b21b'

export const BLACKLIST_LIST_ACTION_UUID = 'df0b9107-e494-447c-9da0-4140ce7e6253'
